import { render, staticRenderFns } from "./BaoCaoKetQuaKinhDoanhSoSanh.vue?vue&type=template&id=670ee9b7&scoped=true"
import script from "./BaoCaoKetQuaKinhDoanhSoSanh.vue?vue&type=script&lang=js"
export * from "./BaoCaoKetQuaKinhDoanhSoSanh.vue?vue&type=script&lang=js"
import style0 from "./BaoCaoKetQuaKinhDoanhSoSanh.vue?vue&type=style&index=0&id=670ee9b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ee9b7",
  null
  
)

export default component.exports